import { render } from "./PositionOfferlist.vue?vue&type=template&id=600f57f0&scoped=true"
import script from "./PositionOfferlist.vue?vue&type=script&lang=js"
export * from "./PositionOfferlist.vue?vue&type=script&lang=js"

import "./PositionOfferlist.vue?vue&type=style&index=0&id=600f57f0&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600f57f0"]])

export default __exports__